module.exports = __webpack_public_path__ + "img/happy.d1357ad9.png";